import BookIndex from "components/shared/book/list";
import { Transition } from "components/shared/column";
import DropdownBtn from "components/shared/dropdown";
import InlineBtn from "components/shared/inlineBtn";
import SharedReactTable from "components/shared/reactTable";
import { dateToView } from "helpers/date";
import { paths } from "helpers/paths";
import { DateRangeColumnFilter, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";
import { namesList as counterpartiesList } from "sources/books/cargoOwners";
import { list as legalPersons } from "sources/books/legalPersons";
import CreateRegistryForm from "./createForm";
import RegistryManualForm from "./manualForm";

class RegistriesList extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            {
                Header: "ID",
                accessor: "id",
                filterable: true,
                filterType: "int",
                Cell: ({ value }) => <Link to={paths.registriesShow(value)}>{value}</Link>,
            },
            {
                Header: "Дата реестра",
                accessor: "date",
                filterable: true,
                filterType: "dateTimeRange",
                sortable: true,
                Filter: DateRangeColumnFilter,
                Cell: ({ value }) => dateToView(value),
                CSVExport: ({ value }) => dateToView(value),
            },
            {
                Header: "Период от",
                accessor: "from",
                filterable: true,
                filterType: "dateTimeRange",
                sortable: true,
                Filter: DateRangeColumnFilter,
                Cell: ({ value }) => dateToView(value),
                CSVExport: ({ value }) => dateToView(value),
            },
            {
                Header: "Период до",
                accessor: "to",
                filterable: true,
                filterType: "dateTimeRange",
                sortable: true,
                Filter: DateRangeColumnFilter,
                Cell: ({ value }) => dateToView(value),
                CSVExport: ({ value }) => dateToView(value),
            },
            {
                Header: "Контрагент",
                accessor: "counterpartyId",
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: counterpartiesList,
                            inputProps: { name: "counterpartyId" },
                            propName: "name",
                        }}
                    />
                ),
                Cell: ({ row: { original } }) => original.counterparty?.displayName || original.counterparty?.name,
                CSVExport: ({ original }) => original.counterparty?.displayName || original.counterparty?.name,
            },
            {
                Header: "Юрлицо",
                accessor: "legalPersonId",
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: legalPersons,
                            inputProps: { name: "legalPersonId" },
                            propName: "name",
                        }}
                    />
                ),
                Cell: ({ row: { original } }) => original.legalPerson?.displayName || original.legalPerson?.name,
                CSVExport: ({ original }) => original.legalPerson?.displayName || original.legalPerson?.name,
            },
            {
                Header: "Создан для УПД",
                accessor: "flags",
                Cell: ({ value }) => (value ? "Да" : "Нет"),
            },
            {
                Header: "Комментарий",
                accessor: "comment",
                filterable: true,
            },
        ];
    }

    renderListComponent = () => (
        <SharedReactTable
            {...this.props}
            isLoadingList={this.props.isLoadingList || this.state?.loading}
            columns={this.state.tableColumns}
            getList={(params) => this.props.getList(params)}
        />
    );

    close = () => this.props.history.push(paths.finances);

    renderHead = () => (
        <div className="book-list__head-wrap">
            <div className="book-list__head">
                <div className="book-list__head-close close close--sm" onClick={this.close} />
                <div className="book-list__head-title">Реестры перевозок{this.renderCounter()}</div>
                <div className="btn-toolbar">{this.props.canEditBooks && this.renderCreateButton()}</div>
            </div>
        </div>
    );

    openCreateForm = () => {
        this.props.modal({
            name: "default",
            title: "Создать реестр перевозок по заявкам",
            windowMod: "wide",
            CustomBody: CreateRegistryForm,
            bodyData: { onSuccess: () => this.props.mergeParams({}) },
        });
    };

    openManualCreateForm = () => {
        this.props.modal({
            name: "default",
            title: "Создать реестр перевозок вручную",
            windowMod: "wide",
            CustomBody: RegistryManualForm,
            bodyData: { onSuccess: () => this.props.mergeParams({}) },
        });
    };

    renderCreateButton = () => (
        <DropdownBtn
            cname="btn btn-brand btn-sm"
            text="Создать"
            items={[
                { text: "Создать по заявкам", action: this.openCreateForm },
                { text: "Создать вручную", action: this.openManualCreateForm },
            ]}
        />
    );

    renderActions() {
        const { mergeParams } = this.props;
        const actions = [{ value: "Обновить", cname: "refresh", active: true, action: mergeParams, params: {} }];
        return actions.map((item, index) => <InlineBtn key={index} {...item} />);
    }

    render() {
        return (
            <div className="page-content">
                <Transition dir="full">
                    <div className="page-book__list book-list list">
                        {this.renderHead()}
                        <div className="container-fluid my-2">{this.renderActions()}</div>
                        {this.renderListComponent()}
                    </div>
                </Transition>
            </div>
        );
    }
}

export default tableContainer(RegistriesList, "finances-registries");
